import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewerPerformanceBreakdownV1Query } from './get-reviewer-performance-breakdown-v1-request';
import type { IGetReviewerPerformanceBreakdownV1Response } from './get-reviewer-performance-breakdown-v1-response';
import { getReviewerPerformanceBreakdownV1ResponseSchema } from './get-reviewer-performance-breakdown-v1-response';

export async function getReviewerPerformanceBreakdownV1Api(
  query: IGetReviewerPerformanceBreakdownV1Query,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReviewerPerformanceBreakdownV1Response>> {
  const params = new URLSearchParams();
  params.set('userId', query.userId);
  if (query.days != null) {
    params.set('days', String(query.days));
  }
  return getRequest<IGetReviewerPerformanceBreakdownV1Response>({
    path: `/sys/reviewer-performance/v1/breakdown?${params.toString()}`,
    schema: getReviewerPerformanceBreakdownV1ResponseSchema,
    options,
  });
}
